function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M4.924 8.823l6.9-6.94a.604.604 0 000-.853l-.848-.853a.598.598 0 00-.849 0L4.5 5.837 1.873 3.193a.598.598 0 00-.849 0l-.848.853a.605.605 0 000 .854l3.9 3.922a.596.596 0 00.848 0z"
});

function SvgCheckinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9"
  }, props), _ref);
}

export default SvgCheckinline;